/**
 * Client-side auth utilities that don't require server-only imports
 */
import { buildLoginUrl } from './authCore';

/**
 * Constructs the login URL with the correct redirect URI and locale.
 * Client-side version that uses window.location.
 * @param locale - The locale to use for the login page
 */
export function getLoginHrefClient(locale: string): string {
  if (typeof window === 'undefined') {
    // During SSR, return a placeholder that will be updated on hydration
    return '#';
  }

  return buildLoginUrl({
    currentUrl: window.location.href,
    origin: window.location.origin,
    locale
  });
}
